var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.255 28.6877H31.4656L27.149 38.1118H2.36963L12.255 28.6877Z",
    fill: "#EFEBE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32422 2.32666H25.5678V34.6848H6.32422V2.32666Z",
    fill: "#0081AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06641 13.2329H25.0933V23.8087H7.06641V13.2329Z",
    fill: "#23B5E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06641 13.4131H24.8529V23.8086H7.06641V13.4131Z",
    fill: "#0099C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06641 3.07764H25.0933V12.7521H7.06641V3.07764Z",
    fill: "#23B5E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06641 3.25806H24.8529V12.7522H7.06641V3.25806Z",
    fill: "#0099C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6162 8.42566C13.6162 8.5584 13.7238 8.66602 13.8566 8.66602H18.0628C18.1956 8.66602 18.3032 8.5584 18.3032 8.42566V7.5844C18.3032 7.45166 18.1956 7.34404 18.0628 7.34404H13.8566C13.7238 7.34404 13.6162 7.45166 13.6162 7.5844V8.42566Z",
    fill: "#2F3881"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.8564 8.00506C13.8564 8.07144 13.9103 8.12524 13.9766 8.12524H17.9425C18.0089 8.12524 18.0627 8.07144 18.0627 8.00506V7.76471C18.0627 7.69833 18.0089 7.64453 17.9425 7.64453H13.9766C13.9103 7.64453 13.8564 7.69833 13.8564 7.76471V8.00506Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8564 7.94501C13.8564 8.01138 13.9103 8.06519 13.9766 8.06519H17.9425C18.0089 8.06519 18.0627 8.01138 18.0627 7.94501V7.70465C18.0627 7.63827 18.0089 7.58447 17.9425 7.58447H13.9766C13.9103 7.58447 13.8564 7.63827 13.8564 7.70465V7.94501Z",
    fill: "#75AFC8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8564 7.82471H18.0627V7.70453C18.0627 7.63815 18.0089 7.58435 17.9425 7.58435H13.9766C13.9103 7.58435 13.8564 7.63815 13.8564 7.70453V7.82471Z",
    fill: "#96C3D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6162 8.42566C13.6162 8.5584 13.7238 8.66602 13.8566 8.66602H18.0628C18.1956 8.66602 18.3032 8.5584 18.3032 8.42566V7.5844C18.3032 7.45166 18.1956 7.34404 18.0628 7.34404H13.8566C13.7238 7.34404 13.6162 7.45166 13.6162 7.5844V8.42566Z",
    fill: "#2F3881"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.8564 8.00506C13.8564 8.07144 13.9103 8.12524 13.9766 8.12524H17.9425C18.0089 8.12524 18.0627 8.07144 18.0627 8.00506V7.76471C18.0627 7.69833 18.0089 7.64453 17.9425 7.64453H13.9766C13.9103 7.64453 13.8564 7.69833 13.8564 7.76471V8.00506Z",
    fill: "#333333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8564 7.94501C13.8564 8.01138 13.9103 8.06519 13.9766 8.06519H17.9425C18.0089 8.06519 18.0627 8.01138 18.0627 7.94501V7.70465C18.0627 7.63827 18.0089 7.58447 17.9425 7.58447H13.9766C13.9103 7.58447 13.8564 7.63827 13.8564 7.70465V7.94501Z",
    fill: "#75AFC8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8564 7.82471H18.0627V7.70453C18.0627 7.63815 18.0089 7.58435 17.9425 7.58435H13.9766C13.9103 7.58435 13.8564 7.63815 13.8564 7.70453V7.82471Z",
    fill: "#96C3D6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18664 24.1392H25.2736L23.2907 25.6414H2.70996L7.18664 24.1392Z",
    fill: "#2F3881"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3296 0.553955L25.574 2.29655V34.6849L29.3296 29.0364V0.553955Z",
    fill: "#0099C9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3896 0.614014L25.574 2.35661H6.34528L14.3372 0.614014H29.3896Z",
    fill: "#23B5E3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24674 24.139L25.2736 24.1108V24.2893L7.21669 24.2292L6.94629 24.2292L7.24674 24.139Z",
    fill: "#23B5E3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94657 24.2292L2.62012 25.6414H2.98065L7.18693 24.2292H6.94657Z",
    fill: "#23B5E3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1548 22.8467C17.8223 22.8386 17.5437 23.1039 17.5357 23.4364L17.5235 23.9425L11.3586 23.7932L11.1077 34.1703L23.9282 35.0169L24.2795 34.4888L24.5121 24.8861L24.5309 24.1119L24.5432 23.6059C24.5512 23.2734 24.2859 22.9948 23.9535 22.9868L18.1548 22.8467Z",
    fill: "#666666"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M11.0691 29.5938C11.0551 29.6748 11.1093 29.7514 11.1903 29.7654L21.653 31.5726C21.734 31.5865 21.8106 31.5324 21.8246 31.4514C21.8246 31.4514 22.542 24.1575 22.461 24.1436L12.47 22.3554C12.3894 22.3413 11.0691 29.5938 11.0691 29.5938Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9983 22.4925L10.7188 29.9025L21.4744 31.7597L22.7539 24.3497L11.9983 22.4925Z",
    fill: "#BCEDFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M21.6192 31.3637L21.8514 24.0856L11.3578 23.4238L11.0317 30.9362L21.6192 31.3637Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7316 23.674L10.4052 31.1866L21.3098 31.6603L21.6362 24.1477L10.7316 23.674Z",
    fill: "#E6FFFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M18.0108 23.145C17.6783 23.137 17.3997 23.4023 17.3917 23.7347L17.3794 24.2408L11.2145 24.0915L10.9635 34.4683L23.9279 35.0158L24.368 25.1844L24.3868 24.4103L24.3991 23.9042C24.4071 23.5717 24.1418 23.2931 23.8094 23.2851L18.0108 23.145Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8036 23.3749C17.4711 23.3669 17.1925 23.6322 17.1845 23.9646L17.1723 24.4707L11.0075 24.3217L10.7565 34.6985L23.9285 35.0174L24.161 25.4146L24.1799 24.6405L24.1921 24.1344C24.2002 23.802 23.9349 23.5234 23.6024 23.5154L17.8036 23.3749Z",
    fill: "#E9C092"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M23.9283 35.0175L11.0073 24.3218L10.7563 34.6986L23.9283 35.0175Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M17.4336 23.5075C17.1011 23.4995 16.8226 23.7648 16.8145 24.0973L16.8023 24.6034L10.6374 24.4541L10.3865 34.8312L23.2071 35.6778L23.5583 35.1497L23.7909 25.547L23.8097 24.7728L23.822 24.2667C23.83 23.9343 23.5647 23.6557 23.2323 23.6477L17.4336 23.5075Z",
    fill: "#666666"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M10.3479 30.2547C10.334 30.3357 10.3881 30.4123 10.4691 30.4263L20.9318 32.2335C21.0128 32.2474 21.0894 32.1933 21.1034 32.1123C21.1034 32.1123 21.8208 24.8184 21.7398 24.8045L11.7488 23.0162C11.6682 23.0022 10.3479 30.2547 10.3479 30.2547Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2771 23.1534L9.99761 30.5634L20.7532 32.4205L22.0327 25.0106L11.2771 23.1534Z",
    fill: "#BCEDFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M20.8981 32.0245L21.1302 24.7465L10.6366 24.0846L10.3105 31.5971L20.8981 32.0245Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0104 24.3349L9.68402 31.8475L20.5886 32.3212L20.915 24.8086L10.0104 24.3349Z",
    fill: "#E6FFFA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M17.2896 23.8059C16.9571 23.7979 16.6785 24.0632 16.6705 24.3956L16.6582 24.9017L10.4933 24.7524L10.2423 35.1292L23.2067 35.6767L23.6468 25.8453L23.6657 25.0712L23.6779 24.5651C23.686 24.2326 23.4207 23.954 23.0882 23.946L17.2896 23.8059Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0824 24.0358C16.7499 24.0277 16.4714 24.293 16.4633 24.6255L16.4511 25.1316L10.2863 24.9826L10.0353 35.3594L23.2073 35.6783L23.4398 26.0755L23.4587 25.3014L23.4709 24.7953C23.479 24.4629 23.2137 24.1843 22.8812 24.1762L17.0824 24.0358Z",
    fill: "#E9C092"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M23.2071 35.6783L10.2861 24.9827L10.0351 35.3595L23.2071 35.6783Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0891 16.2958C15.7527 16.0649 15.2886 16.151 15.0577 16.4874L14.7061 16.9995L8.46827 12.7168L1.25991 23.217L13.8731 32.6743L14.5879 32.3668L21.2587 22.6504L21.7966 21.8672L22.1482 21.3551C22.3791 21.0187 22.2929 20.5546 21.9566 20.3237L16.0891 16.2958Z",
    fill: "#666666"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M4.28564 18.4863C4.21705 18.5602 4.22138 18.6752 4.2953 18.7438L13.841 27.6095C13.915 27.6781 14.03 27.6737 14.0986 27.5998C14.0986 27.5998 19.7214 20.5818 19.6475 20.5133L10.574 11.9831C10.5006 11.9147 4.28564 18.4863 4.28564 18.4863Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99796 11.8085L3.71953 18.5693L13.5329 27.6825L19.8113 20.9216L9.99796 11.8085Z",
    fill: "#BCEDFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M13.9468 27.3721L19.0601 20.0454L8.71555 12.3366L3.34851 19.8414L13.9468 27.3721Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90424 12.1744L2.53692 19.6791L13.43 27.4699L18.7974 19.9651L7.90424 12.1744Z",
    fill: "#E6FFFA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M15.7414 16.5062C15.405 16.2753 14.9409 16.3614 14.71 16.6979L14.3584 17.2099L8.12062 12.9273L0.912365 23.427L13.8737 32.6732L20.9111 22.8608L21.4489 22.0776L21.8005 21.5655C22.0314 21.2291 21.9453 20.765 21.6089 20.5341L15.7414 16.5062Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3748 16.6037C15.0384 16.3728 14.5743 16.4589 14.3434 16.7953L13.9919 17.3074L7.75392 13.0252L0.545683 23.5249L13.8736 32.6751L20.5443 22.9587L21.0822 22.1755L21.4338 21.6635C21.6648 21.3271 21.5786 20.863 21.2422 20.632L15.3748 16.6037Z",
    fill: "#E9C092"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M13.8736 32.6751L7.75391 13.0251L0.545673 23.5249L13.8736 32.6751Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62012 25.6414L23.1708 25.7615V37.479H2.62012V25.6414Z",
    fill: "#0099C9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62012 25.7615L23.1708 25.7633V25.9417H2.62012V25.7615Z",
    fill: "#23B5E3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62012 25.6414H23.321L23.1407 25.7916H2.62012V25.6414Z",
    fill: "#0081AF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0112 31.1996C10.0112 31.3323 10.1188 31.4399 10.2516 31.4399H14.4579C14.5906 31.4399 14.6982 31.3323 14.6982 31.1996V30.3583C14.6982 30.2256 14.5906 30.118 14.4579 30.118H10.2516C10.1188 30.118 10.0112 30.2256 10.0112 30.3583V31.1996Z",
    fill: "#2F3881"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M10.2515 30.779C10.2515 30.8454 10.3053 30.8992 10.3716 30.8992H14.3376C14.4039 30.8992 14.4577 30.8454 14.4577 30.779V30.5386C14.4577 30.4723 14.4039 30.4185 14.3376 30.4185H10.3716C10.3053 30.4185 10.2515 30.4723 10.2515 30.5386V30.779Z",
    fill: "#333333"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2515 30.7189C10.2515 30.7853 10.3053 30.8391 10.3716 30.8391H14.3376C14.4039 30.8391 14.4577 30.7853 14.4577 30.7189V30.4786C14.4577 30.4122 14.4039 30.3584 14.3376 30.3584H10.3716C10.3053 30.3584 10.2515 30.4122 10.2515 30.4786V30.7189Z",
    fill: "#75AFC8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2515 30.5986H14.4577V30.4785C14.4577 30.4121 14.4039 30.3583 14.3376 30.3583H10.3716C10.3053 30.3583 10.2515 30.4121 10.2515 30.4785V30.5986Z",
    fill: "#96C3D6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2739 24.1091L23.1708 25.7616V37.4791L25.2739 34.1441V24.1091Z",
    fill: "#23B5E3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9301 25.7614L25.1535 24.109L25.2736 24.109L23.1705 25.7614L22.9301 25.7614Z",
    fill: "#0081AF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherFile);
export default __webpack_public_path__ + "static/media/otherFile.5d5860574b4c1b57c099a99954dd9617.svg";
export { ForwardRef as ReactComponent };